import { useReadContract } from "wagmi";

const useGetUserMintedCount = (address, abi, userAddress, provider) => {
  return useReadContract({
    address: address,
    abi: abi,
    functionName: "whitelistMints",
    args: [userAddress],
    provider: provider,
  });
};

export default useGetUserMintedCount;
